import { Globe, Twitter, Github, Mail } from 'lucide-react'

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <Globe className="w-6 h-6 text-primary-400" />
              <span className="text-xl font-bold">Domain Brainstorm</span>
            </div>
            <p className="text-gray-400 text-sm">
              Find the perfect domain name for your project. Free, fast, and unlimited.
            </p>
          </div>

          {/* Features */}
          <div>
            <h3 className="font-semibold mb-4">Features</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Domain Suggestions</li>
              <li>Availability Checking</li>
              <li>Multiple TLD Support</li>
              <li>Bulk Domain Check</li>
              <li>Real-time Results</li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="font-semibold mb-4">Resources</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <a href="#" className="hover:text-white transition-colors">API Documentation</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">Domain Tips</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">Registrar Partners</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              </li>
              <li>
                <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4">Connect</h3>
            <div className="flex space-x-4">
              <a 
                href="https://twitter.com/domainbrainstorm" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a 
                href="https://github.com/yourusername/domain-brainstorm" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary-400 transition-colors"
              >
                <Github className="w-5 h-5" />
              </a>
              <a 
                href="mailto:hello@domainbrainstorm.com"
                className="text-gray-400 hover:text-primary-400 transition-colors"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
            <p className="text-xs text-gray-500 mt-4">
              Built with ❤️ using Cloudflare Workers
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-500">
          <p>&copy; 2025 Domain Brainstorm. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}
